import React from 'react';
import { Box, styled } from '@mui/system';
import { Typography } from '@mui/material';
import { AuthBackground } from '../../../../shared/components/icons';
const InfoContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  left: 0,
  top: 0,
  width: '50%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  jsutifyContent: 'center',
  alignItems: 'center',
  '.info': {},
  [theme.breakpoints.down(1025)]: {
    display: 'none'
  }
}));

function ClaraInfo() {
  return (
  <InfoContainer sx={{ zIndex: 88 }}>
    <Box sx={{m: 'auto'}} >
      <div style={{
          overflow: "hidden",
          height: "207px",
          width: "343px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <AuthBackground/>
      </div>
      <Box className='info'>
        <Typography
          variant='h5'
          color='white'
          sx={{
            textAlign: 'center',
            fontSize: '24px',
            fontWeight: 400,
            opacity: 0.7
            }}>
          a community of creators changing
          <br />
          the future of brand deals
        </Typography>
      </Box>
    </Box>
  </InfoContainer>);
}

export default ClaraInfo;
